import React from "react";
import { Select, Tag } from "antd";

import type { Label } from "../../../../core/data/redux/projects/types";

interface LabelsPickerProps {
  labels: Label[];
  value: number[];
  onChange: (labelIds: number[]) => void;
  disabled?: boolean;
  size?: "small" | "middle" | "large";
}

const LabelsPicker: React.FC<LabelsPickerProps> = ({
  labels,
  value,
  onChange,
  disabled,
  size = "middle",
}) => {
  return (
    <Select
      mode="multiple"
      maxTagCount="responsive"
      style={{ width: "100%", minHeight: 36 }}
      placeholder="Add labels"
      value={value}
      onChange={onChange}
      disabled={disabled}
      size={size}
      options={labels.map((l) => ({
        value: l.id,
        label: (
          <span className="d-inline-flex align-items-center gap-2">
            <span
              className="d-inline-block rounded-circle"
              style={{
                width: 8,
                height: 8,
                background: l.color || "#6B7280",
              }}
            />
            {l.name}
          </span>
        ),
      }))}
      tagRender={({ label, value: v, closable, onClose }) => {
        const found = labels.find((l) => l.id === v);
        return (
          <Tag
            closable={closable}
            onClose={onClose}
            color={found?.color || "default"}
            style={{ marginRight: 4, marginTop: 2, marginBottom: 2, maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis" }}
          >
            {label}
          </Tag>
        );
      }}
    />
  );
};

export default LabelsPicker;
